/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.4.1'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/**
 * Created by blue on 29.11.15.
 */


/*
 * jApp
 */

jApp = {
    init: function () {
        this.onload();
    },
    onload: function () {
        if (typeof onloadfcs !== 'undefined') {
            onloadfcs.forEach(function (fc) {
                fc();
            });
        }
        onloadfcs = [];
        $('.btn-back').bind('click', function () {
            var backUrl = $(this).data('back-url');
            if (backUrl) {
                return document.location.href = backUrl;
            }
            window.history.go(-1);
        });

        //
        // init datepickers
        //
        $('body').on('click', '.datepicker', function () {
            jApp.showDatePicker(this, $(this).data('default-date'));
        });
        $('body').on('click', '.datepicker-icon', function () {
            var input = $($(this).data('alt-field'));
            jApp.showDatePicker(input, $(this).data('default-date'));
        });
    },
    jget: function (url, callback) {
        this.jreq(url, null, callback, 'get');
    },
    jput: function (url, params, callback) {
        this.jreq(url, params, callback, 'put');
    },
    jdelete: function (url, params, callback) {
        this.jreq(url, params, callback, 'delete');
    },
    jpost: function (url, params, callback) {
        this.jreq(url, params, callback, 'post');
    },
    jreq: function (url, params, callback, type) {
        var d = new Date;
        $.ajax({
            url: url,
            dataType: 'json',
            data: params,
            type: type ? type : 'get',
            success: function (json) {
                $.each(json, function (n, d) {
                    switch (n) {
                        case 'html':
                            $.each(d, function (t, h) {
                                $('#' + t).html(h);
                            });
                            break;
                        case 'input':
                            $.each(d, function (t, h) {
                                $('#' + t).val(h);
                            });
                            break;
                        case 'select':
                            $.each(d, function (t, h) {
                                var element = $('#' + t);
                                element.html("");

                                var selected = element.attr("data-selected");
                                $.each(h, function (id, value) {
                                    var html = "<option value='" + id + "'";

                                    if (selected === id) {
                                        html += " selected";
                                    }

                                    html += ">" + value + "</option>";
                                    element.append(html);
                                });

                                if (selected) {
                                    element.removeAttribute("data-selected");
                                }
                            });
                            break;
                        case 'show':
                            $.each(d, function (t, h) {
                                $('#' + t).show();
                            });
                            break;
                        case 'hide':
                            $.each(d, function (t, h) {
                                $('#' + t).hide();
                            });
                            break;
                        case 'focus':
                            $('#' + d).focus();
                            break;
                        case 'text':
                            $.each(d, function (t, h) {
                                $('#' + t).text(h);
                            });
                            break;
                        case 'class-add':
                            $.each(d, function (t, h) {
                                $('#' + t).addClass(h);
                            });
                            break;
                        case 'class-remove':
                            $.each(d, function (t, h) {
                                $('#' + t).removeClass(h);
                            });
                            break;
                        case 'class-toggle':
                            $.each(d, function (t, h) {
                                $('#' + t).toggleClass(h);
                            });
                            break;
                        case 'reload':
                            if (d == 'page') {
                                document.location.reload();
                                return;
                            } else {
                                document.location.href = d;
                            }
                            break;
                        case 'error':
                        case 'message':
                            alert(d);
                            break;
                        case 'callback':
                            var callback = new Function(d.func);
                            if (typeof callback === "function") {
                                callback();
                            }
                            break;
                        case 'console':
                            jApp.log(d);
                            break;
                        case 'popup':
                            $.each(d, function (t, h) {

                                $('#popup-success').text(h.label);
                            });

                            $('#popup-success').show();
                            window.setTimeout(function () {
                                $('#popup-success').hide();
                                $('#popup-success').text('');
                            }, 2000);
                            break;
                    }
                });

                if (typeof callback == "function") {
                    callback(json);
                }
            },
            error: function (xhr) {
                jApp.onAjaxError(xhr);
            }
        });
    },
    onAjaxError: function (xhr) {
        if (xhr.responseText.substring(0, 8) == "<script>") {

            $('#page-wrapper').prepend($(xhr.responseText));
        } else {

            if (xhr.status > 399) {

                console.log(xhr.status);
                $('#page-wrapper').prepend($('<div class="alert alert-danger">Chyba: '
                    + xhr.status + '</div>'));
                jApp.log(xhr.status);

            } else {

                alert('json data error');
                jApp.log(xhr.responseText);
            }
        }
    },
    log: function (str) {
        if (window.console) {
            console.log(str);
        }
    },
    goBack: function (param) {
        var url = document.referrer;
        if (param.length > 0) {
            if (url.indexOf('?') < 0) {
                url += '?' + param;
            } else {
                url += '&' + param;
            }
        }
        document.location = url;
    },
    submitForm: function (form, callback) {
        var params = {};
        $(form).find('[name]').each(function () {
            // checkbox input
            if ($(this).prop('type') == 'checkbox') {
                if (!$(this).prop('checked')) {
                    return;
                }
            }
            // radio input
            if ($(this).prop('type') == 'radio') {
                if (!$(this).prop('checked')) {
                    return;
                }
            }
            // array brackets in name
            if (this.name.search(/\[\]/) > 0) {
                if (!params[this.name]) {
                    params[this.name] = new Array;
                }
                params[this.name].push(this.value);
            } else {
                params[this.name] = this.value;
            }
        });

        jApp.jpost($(form).prop('action'), params, function (json) {
            if (typeof callback == 'function') {
                callback(json);
            }
        });
    },
    confirmDelete: function () {
        return confirm('Opravdu chcete smazat záznam?');
    },
    getJsonData: function (json, prop) {
        if (json.hasOwnProperty('data')) {
            if (json.data.hasOwnProperty(prop)) {
                return json.data[prop];
            }
        }
        return null;
    },
    showDatePicker: function (input, init_date) {
        if (!$(input).val()) {
            var value_source = $(input).data('value-source');
            if (value_source) {
                $(input).val($(value_source).val());
            }
        }
        if (typeof jQuery.fn.datepicker !== "undefined") {
            $(input).datepicker({
                numberOfMonths: 2,
                dateFormat: "d. m. yy",
                defaultDate: init_date,
                minDate: new Date(),
                //onSelect: function (date) {
                //    var set_to_date = $(this).data('set-to-date');
                //    if (set_to_date) {
                //        if (!$(set_to_date).val()) {
                //            $(set_to_date).val(date);
                //        }
                //    }
                //    var set_from_date = $(this).data('set-from-date');
                //    if (set_from_date) {
                //        if (!$(set_from_date).val()) {
                //            $(set_from_date).val(date);
                //        }
                //    }
                //}
            });
            //if (init_date) {
            //    $(input).datepicker('setDate', init_date);
            //}
            $(input).datepicker('show');
        }
        $(input).select();
    }
};

+function ($) {

    $('.fancybox').fancybox();

    $('#contact-form').bind('submit', function (e) {

        var form = this;
        $(form).find('button[type="submit"]').prop('disabled', true);

        e.preventDefault();
        jApp.submitForm(this, function(json) {
            form.reset();
            $(form).find('button[type="submit"]').prop('disabled', false);
            // $('#result').html(json.html.result);
        });
        return false;
    });

}(jQuery);


